import { ConstructionYearContainer } from '../../containers/advancedFilters/ConstructionYearContainer';
import { IFilter } from '../../types/advancedFilters';

export const constructionYear: IFilter = {
  component: ConstructionYearContainer,
};
